import React, {useState, useEffect} from 'react';
import session from '../services/session';
import moment from "moment";
import {swalDeleteForm, swalError, swalSuccess, swalComment} from "../utils/swal";
import commentService from "../services/comment";
import {Edit, DeleteForever} from '@material-ui/icons';
import {IconButton} from "@material-ui/core";

export default function CommentBox(props) {

    const handleEdit = e => {
        e.preventDefault();
        const obj = {
            id: props.comment._id,
            text: props.comment.text
        };

        props.setCommentToUpdate(obj);
    }

    const handleDelete = e => {
        e.preventDefault();
        swalDeleteForm(() => {
            props.deleteComment(props.comment._id);
        });
    }

    return (
        <div className="comment-box">
            <div className="row">
                <div className="col-2 col-sm-2 col-md-2 text-center">
                    <img className="img-circle" src={props.comment.userId && props.comment.userId.picture} />
                </div>
                <div className="col-6 col-sm-6 col-md-6 text-left">
                    <p style={{paddingLeft: '10px'}}>
                        <span className="comment-username">{props.comment.userId && props.comment.userId.fullname}</span>
                        <br/>
                        <span className="text-right comment-date">{moment(props.comment.date).fromNow()}</span>
                    </p>
                </div>
                <div className="col-4 col-sm-4 col-md-4 text-right comment-icons">
                    {
                        session.get('user')._id === props.comment.userId._id &&
                        <span>
                            <IconButton className="text-white" onClick={handleEdit}>
                                <Edit fontSize="small" />
                            </IconButton>
                            <IconButton className="text-white" onClick={handleDelete}>
                                <DeleteForever />
                            </IconButton>
                        </span>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 text-left linebreaks">
                    {props.comment.text}
                </div>
            </div>
        </div>
    );
}